import { validateValidShippingPrice } from './validate-valid-shipping-price';
import { getAllProviders } from './next-shipping-selectors';

const errors = {
    empty: 'Ange fraktsätt och fraktkostnad',
    invalid: 'Fraktsätt har ett felaktigt värde',
    duplicate: 'Det alternativa fraktsättet är identiskt med det första',
    weight: 'Fraktsätt: Du behöver ange vikt för paketet'
};

export function validate(newState) {
    let hasAnyNonValidOption = false;
    let hasAnyValidOption = false;
    let weightIsInvalid = false;

    getAllProviders(newState).forEach(provider => {
        provider.products.forEach(product => {
            if (!product.selected) {
                // Not selected, set to valid without error
                product.isValid = true;
                product.validationError = null;
                product.isWeightValid = true;
                product.weightValidationError = null;
            } else {
                const errorMessage = validateValidShippingPrice(
                    product,
                    provider.useAdvancedWidget
                );
                if (errorMessage) {
                    product.isValid = false;
                    product.validationError = errorMessage;
                    hasAnyNonValidOption = true;
                } else {
                    product.isValid = true;
                    product.validationError = null;
                    hasAnyValidOption = true;
                }
                if (provider.useAdvancedWidget && !product.productId) {
                    product.isWeightValid = false;
                    product.weightValidationError = errors.weight;
                    weightIsInvalid = true;
                } else {
                    product.isWeightValid = true;
                    product.weightValidationError = null;
                }
            }
        });
    });

    const getFirstValidationError = () => {
        if (!newState.takeawayDeliveryAccepted && !hasAnyValidOption)
            return errors.empty;
        if (hasAnyNonValidOption) return errors.invalid;
        if (weightIsInvalid) return errors.weight;
        if (
            newState.selectedShippingOptions.length > 1 &&
            JSON.stringify(newState.selectedShippingOptions[0]) ==
                JSON.stringify(newState.selectedShippingOptions[1])
        )
            return errors.duplicate;
        return null;
    };

    newState.validationError = getFirstValidationError();
    return newState;
}
